import { preventDefault } from "@/helpers/utils"
import { ActionsCell } from "@/molecules/ActionsCell"

import type { RecurringReportsActionsCellComponent } from "."

export const RecurringReportsActionsCell: RecurringReportsActionsCellComponent =
  (props) => {
    const { noPermissions, t, onEdit, onDelete, isAdmin } = props
    const editKey = "general.edit"
    const deleteKey = "general.delete"
    const disabled = !isAdmin
    const items = [
      { key: editKey, label: t(editKey), disabled },
      { key: deleteKey, label: t(deleteKey), disabled }
    ]

    return function RecurringReportsActionsCellComponent(record) {
      return (
        <ActionsCell
          noPermissions={noPermissions}
          disabled={noPermissions}
          items={items}
          onClick={({ key, domEvent }) => {
            preventDefault(domEvent)

            if (key === editKey) onEdit(record)
            if (key === deleteKey) onDelete(record)
          }}
        />
      )
    }
  }
